import {
    Component,
    ViewChild,
    ViewEncapsulation,
    ElementRef,
    OnInit,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { LoggerService } from "@wdpr/ra-angular-logger";
import { StoryAbstractComponent } from "../shared/story-abstract.component";

import { OneIDService } from "./oneID/one-id.service";
import { CookieService } from "ngx-cookie-service";

import { ILeadGen } from "./interfaces/iLeadGen";
import { ArrayMapperService } from '@app/services/array-mapper/array-mapper.service';

@Component({
    selector: "pixie-lead-gen-dcl",
    templateUrl: "./leadgen.component.html",
    styleUrls: ["./leadgen.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class LeadgenComponent extends StoryAbstractComponent implements OnInit {
    @ViewChild("leadGenView", { read: ElementRef }) leadGenView: ElementRef;

    container: string;
    getNewsletter: any;
    modalOneId: any;
    isSubscribed: any;
    isLoggedOrSubscribe = false;
    marketingCodes: string[];
    contentLeadGen: ILeadGen = {
        ctaButtonText: "",
        isDclLoggedIn: false,
        isEpcUserSubscribed: false,
        signUpParagraph: "",
        signUpTitle: "",
        thanksParagraph: "",
        thanksTitle: "",
    };

    constructor(
        private _logger: LoggerService,
        private _oneIDService: OneIDService,
        sanitizer: DomSanitizer,
        cookieService: CookieService,
        arrayMapperService: ArrayMapperService) {
        super(sanitizer, cookieService, arrayMapperService);
        this.marketingCodes = _oneIDService.marketingCodes;
    }

    getTemplateBlockGroups(storyData) {
        const storyDataDescriptions = storyData.modules[0];
        this.contentLeadGen.isDclLoggedIn = storyDataDescriptions.descriptions.isDclLoggedIn;
        this.contentLeadGen.isEpcUserSubscribed = storyDataDescriptions.descriptions.isEpcUserSubscribed;
        this.contentLeadGen.ctaButtonText = storyDataDescriptions.sections.ctaButtonText;
        this.contentLeadGen.signUpParagraph = storyDataDescriptions.sections.signUpParagraph;
        this.contentLeadGen.signUpTitle = storyDataDescriptions.sections.signUpTitle;
        this.contentLeadGen.thanksParagraph = storyDataDescriptions.sections.thanksParagraph;
        this.contentLeadGen.thanksTitle = storyDataDescriptions.sections.thanksTitle;
        this.contentLeadGen.backgroundImg = storyDataDescriptions.media.dclLeadGenBannerBackgroundDesktop.url;

        return [storyDataDescriptions];
    }

    public async ngOnInit() {
        try {
            this.modalOneId = await this._oneIDService;
            this.isSubscribed = localStorage.getItem('subscribed');
            document.addEventListener("navigation", (event: any) => {
                if (event?.detail?.event === "userInformation") {
                    this.modalOneId.statusOneID();
                    this._oneIDService.isSubscribedNewsletter.subscribe(data => {
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].code == this.marketingCodes[0] && data[i].subscribed) {
                                this.isSubscribed = data[i].subscribed;
                                localStorage.setItem('subscribed', 'true');
                            }
                        }
                    });
                    setTimeout(() => {
                        this.validationOneID();
                    },
                        500);
                }

                if (event?.detail?.event === "oneId-logout") {
                    localStorage.removeItem('subscribed');
                }

                if (event?.detail?.event === "oneId-opt-in") {
                    this.isLoggedOrSubscribe = true;
                }

            });
        } catch (error) {
            this._logger.error("ngOnInit error:", error);
        }
    }

    validationOneID(): any {
        if (localStorage.getItem('subscribed') === "true") {
            this.isSubscribed = true;
        }
    }
    message() {
        document.dispatchEvent(new CustomEvent("navigationAuth", {
            detail: {
                method: "handleSubscription"
            }
        }));
    }
}
